import { render } from "./profileDropdown.vue?vue&type=template&id=1c8d7408"
import script from "./profileDropdown.vue?vue&type=script&lang=js"
export * from "./profileDropdown.vue?vue&type=script&lang=js"

import "./profileDropdown.vue?vue&type=style&index=0&id=1c8d7408&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__